(function () {
  if (window.__spCatLottieBound) return;
  window.__spCatLottieBound = true;

  // Map of collection handle -> Lottie filename (for client-side injection)
  // Populated from theme.liquid via window.SP_CAT_LOTTIES (URL-prefixed)
  function getMap() { return window.SP_CAT_LOTTIES || {}; }

  function normalizeTitle(s) {
    return (s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  function fallbackByTitle(title) {
    var t = normalizeTitle(title);
    if (t.indexOf('usi') >= 0 && t.indexOf('cabine') >= 0) return 'usi-cabine-de-dus';
    if (t.indexOf('cadite') >= 0) return 'cadite-de-dus';
    if (t.indexOf('cabine') >= 0) return 'cabine-de-dus';
    if (t.indexOf('rigole') >= 0) return 'rigole-liniare';
    if (t.indexOf('wc') >= 0 || t.indexOf('bideu') >= 0 || t.indexOf('vase') >= 0) return 'vase-wc-bideuri';
    if (t.indexOf('lavoare') >= 0) return 'lavoare';
    if (t.indexOf('cazi') >= 0) return 'cazi-de-baie';
    if (t.indexOf('baterii') >= 0) return 'baterii-baie';
    if (t.indexOf('sisteme') >= 0 && t.indexOf('dus') >= 0) return 'sisteme-de-dus';
    if (t.indexOf('bucatarie') >= 0) return 'bucatarie';
    if (t.indexOf('accesorii') >= 0 || t.indexOf('mobilier') >= 0) return 'accesorii-mobilier-baie';
    return null;
  }

  function findLottieUrl(href, title) {
    var map = getMap();
    var handle = '';
    var m = (href || '').match(/\/collections\/([^/?#]+)/);
    if (m) handle = m[1];
    if (handle && map[handle]) return map[handle];
    // alias by handle keywords
    if (handle) {
      if (/cazi/.test(handle)) return map['cazi-de-baie'];
      if (/usi/.test(handle) && /cabine/.test(handle)) return map['usi-pentru-cabine-de-dus'];
      if (/cabine/.test(handle)) return map['cabine-de-dus'];
      if (/cadite/.test(handle)) return map['cadite-de-dus'];
      if (/rigole/.test(handle)) return map['rigole-liniare'];
      if (/(wc|bideuri|vase)/.test(handle)) return map['vase-wc-si-bideuri'];
      if (/lavoare/.test(handle)) return map['lavoare'];
      if (/baterii/.test(handle)) return map['baterii-baie'];
      if (/(sisteme-de-dus|dusuri)/.test(handle)) return map['sisteme-de-dus'];
      if (/bucatarie/.test(handle)) return map['bucatarie'];
      if (/(accesorii|mobilier|produse-de-baie)/.test(handle)) return map['accesorii-mobilier-baie'];
    }
    var key = fallbackByTitle(title);
    if (key && map[key]) return map[key];
    return null;
  }

  function injectIcon(a) {
    if (!a || a.querySelector(':scope > .sp-cat-icon')) return;
    if (a.closest('.t4s-sub-menu')) return; // top-level only
    var lazyParent = a.closest('.t4s-lazy_menu');
    if (!lazyParent) return;
    var titleEl = a.querySelector('span') || a;
    var lottieUrl = findLottieUrl(a.getAttribute('href') || '', titleEl.textContent || '');
    if (!lottieUrl) return;
    var wrap = document.createElement('span');
    wrap.className = 'sp-cat-icon';
    var lp = document.createElement('lottie-player');
    lp.setAttribute('src', lottieUrl);
    lp.setAttribute('speed', '1');
    lp.setAttribute('loop', '');
    lp.setAttribute('aria-hidden', 'true');
    lp.className = 'sp-cat-lottie';
    wrap.appendChild(lp);
    a.insertBefore(wrap, a.firstChild);
  }

  function processRoot(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches('a') && root.parentElement) {
      // single anchor passed
      var li = root.closest('.t4s-menu-item');
      if (li) injectIcon(root);
      return;
    }
    var anchors;
    try {
      anchors = root.querySelectorAll('.t4s-lazy_menu .t4s-menu-item > a');
    } catch (_) { return; }
    anchors.forEach(injectIcon);
  }

  // Hover trigger logic
  var lastLi = null;
  var hoverTimer = null;

  function getLottie(li) {
    if (!li) return null;
    return li.querySelector(':scope > a > .sp-cat-icon > lottie-player.sp-cat-lottie');
  }
  function stopAt(li) { var lp = getLottie(li); if (lp && lp.stop) try { lp.stop(); } catch (_) {} }
  function playAt(li) {
    var lp = getLottie(li);
    if (lp && lp.play) try { if (lp.seek) lp.seek(0); lp.play(); } catch (_) {}
  }

  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    var li = t && t.closest ? t.closest('.t4s-lazy_menu .t4s-menu-item') : null;
    if (li === lastLi) return;
    if (lastLi) stopAt(lastLi);
    clearTimeout(hoverTimer);
    lastLi = li;
    if (li) hoverTimer = setTimeout(function () { playAt(li); }, 250);
  }, true);

  document.addEventListener('mouseout', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var nav = t.closest('.t4s-sub-menu, .t4s-lazy_menu, .t4s-categories__wrapper');
    if (!nav) return;
    if (e.relatedTarget && nav.contains(e.relatedTarget)) return;
    if (lastLi) stopAt(lastLi);
    clearTimeout(hoverTimer);
    lastLi = null;
  }, true);

  // Observe DOM for lazy-loaded menu content
  function startObserving() {
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          processRoot(n);
        });
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
    // Initial pass
    processRoot(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }

  // ============================================================
  // MOBILE HAMBURGER — play Lottie only when category is expanded
  // (Kalles toggles class `is--opend` on .t4s-menu-item-has-children)
  // ============================================================
  function getMobileLottie(li) {
    if (!li) return null;
    return li.querySelector(':scope > a .sp-mb-cat-icon > lottie-player');
  }

  function startMobileObserver() {
    var obs = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type !== 'attributes' || m.attributeName !== 'class') return;
        var li = m.target;
        if (!li.classList) return;
        if (!li.classList.contains('t4s-menu-item')) return;
        if (!li.closest('.t4s-mb__menu')) return;
        var isOpen = li.classList.contains('is--opend');
        var lp = getMobileLottie(li);
        if (!lp) return;
        try {
          if (isOpen) {
            if (typeof lp.seek === 'function') lp.seek(0);
            if (typeof lp.play === 'function') lp.play();
          } else {
            if (typeof lp.stop === 'function') lp.stop();
          }
        } catch (_) {}
      });
    });
    obs.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startMobileObserver);
  } else {
    startMobileObserver();
  }
})();
